export default function formatSessionDate(value) {
  if (!value) {
    return ''
  }

  const isoDate = String(value).slice(0, 10)
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/)

  if (!match) {
    return ''
  }

  const [, year, month, day] = match
  return `${day}/${month}/${year}`
}
